export const settingConstants = {
  SETTING_SHOW_AUTH_FORM: "SETTING_SHOW_AUTH_FORM",
  SETTING_GET_TRANSFER_LIMITS_REQUEST: "SETTING_GET_TRANSFER_LIMITS_REQUEST",
  SETTING_GET_TRANSFER_LIMITS_COMPLETE: "SETTING_GET_TRANSFER_LIMITS_COMPLETE",
  SETTING_GET_TRANSFER_LIMITS_ERROR: "SETTING_GET_TRANSFER_LIMITS_ERROR",

  SETTING_ADD_TRANSFER_LIMIT_REQUEST: "SETTING_ADD_TRANSFER_LIMIT_REQUEST",
  SETTING_ADD_TRANSFER_LIMIT_COMPLETE: "SETTING_ADD_TRANSFER_LIMIT_COMPLETE",
  SETTING_ADD_TRANSFER_LIMIT_ERROR: "SETTING_ADD_TRANSFER_LIMIT_ERROR",

  RESET_TRANSFER_LIMIT_SETTING: "RESET_TRANSFER_LIMIT_SETTING",
  SETTING_SET_INITIAL: "SETTING_SET_INITIAL",

  RESET_DEFAULT_ACCOUNT_SETTING: "RESET_DEFAULT_ACCOUNT_SETTING",

  SETTING_CHANGE_PASSCODE_REQUEST: "SETTING_CHANGE_PASSCODE_REQUEST",
  SETTING_CHANGE_PASSCODE_COMPLETE: "SETTING_CHANGE_PASSCODE_COMPLETE",
  SETTING_CHANGE_PASSCODE_ERROR: "SETTING_CHANGE_PASSCODE_ERROR",
  SETTING_CHANGE_PASSWORD_REQUEST: "SETTING_CHANGE_PASSWORD_REQUEST",
  SETTING_CHANGE_PASSWORD_COMPLETE: "SETTING_CHANGE_PASSWORD_COMPLETE",

  SETTING_AUTHENTICATE_REQUEST: "SETTING_AUTHENTICATE_REQUEST",
  SETTING_AUTHENTICATE_COMPLETE: "SETTING_AUTHENTICATE_COMPLETE",
  SETTING_AUTHENTICATE_ERROR: "SETTING_AUTHENTICATE_ERROR",

  SETTING_CHANGE_PASSCODE_VALIDATE_REQUEST:
    "SETTING_CHANGE_PASSCODE_VALIDATE_REQUEST",
  SETTING_CHANGE_PASSCODE_VALIDATE_COMPLETE:
    "SETTING_CHANGE_PASSCODE_VALIDATE_COMPLETE",
  SETTING_CHANGE_PASSCODE_VALIDATE_ERROR:
    "SETTING_CHANGE_PASSCODE_VALIDATE_ERROR",

  SETTING_CHANGE_PASSCODE_OTP_CONFIRM_REQUEST:
    "SETTING_CHANGE_PASSCODE_OTP_CONFIRM_REQUEST",
  SETTING_CHANGE_PASSCODE_OTP_CONFIRM_COMPLETE:
    "SETTING_CHANGE_PASSCODE_OTP_CONFIRM_COMPLETE",
  SETTING_CHANGE_PASSCODE_OTP_CONFIRM_ERROR:
    "SETTING_CHANGE_PASSCODE_OTP_CONFIRM_ERROR",
  ON_CLOSE_SETTING_CHANGE_PASSCODE_OTP_CONFIRM_RETRY:
    "ON_CLOSE_SETTING_CHANGE_PASSCODE_OTP_CONFIRM_RETRY",

  SETTING_CHANGE_PASSCODE_OTP_RESEND_REQUEST:
    "SETTING_CHANGE_PASSCODE_OTP_RESEND_REQUEST",
  SETTING_CHANGE_PASSCODE_OTP_RESEND_COMPLETE:
    "SETTING_CHANGE_PASSCODE_OTP_RESEND_COMPLETE",
    SETTING_CHANGE_PASSCODE_OTP_RESEND_ERROR:
    "SETTING_CHANGE_PASSCODE_OTP_RESEND_ERROR",

  CURRENT_PASSWORD_SCREEN: "CURRENT_PASSWORD_SCREEN",
  ENTER_NEW_PASSWORD_SCREEN: "ENTER_NEW_PASSWORD_SCREEN",
  ENTER_OTP_SCREEN: "ENTER_OTP_SCREEN",
  PASSWORD_RESET_SUCCESS_SCREEN: "PASSWORD_RESET_SUCCESS_SCREEN",
  // ----settings ---

  SETTING_GET_ALL_ACCOUNTS_REQUEST: "SETTING_GET_ALL_ACCOUNTS_REQUEST",
  SETTING_GET_ALL_ACCOUNTS_COMPLETE: "SETTING_GET_ALL_ACCOUNTS_COMPLETE",
  SETTING_GET_ALL_ACCOUNTS_ERROR: "SETTING_GET_ALL_ACCOUNTS_ERROR",

  SETTING_GET_ALL_NOTIFICATION_CATEGORY_REQUEST:
    "SETTING_GET_ALL_NOTIFICATION_CATEGORY_REQUEST",
  SETTING_GET_ALL_NOTIFICATION_CATEGORY_COMPLETE:
    "SETTING_GET_ALL_NOTIFICATION_CATEGORY_COMPLETE",

  SETTING_UPDATE_NOTIFICATION_CATEGORY_REQUEST:
    "SETTING_UPDATE_NOTIFICATION_CATEGORY_REQUEST",
  SETTING_UPDATE_NOTIFICATION_CATEGORY_COMPLETE:
    "SETTING_UPDATE_NOTIFICATION_CATEGORY_COMPLETE",

  SETTING_GET_SELECTED_ACCOUNTS_REQUEST:
    "SETTING_GET_SELECTED_ACCOUNTS_REQUEST",
  SETTING_GET_SELECTED_ACCOUNTS_COMPLETE:
    "SETTING_GET_SELECTED_ACCOUNTS_COMPLETE",
  SETTING_GET_SELECTED_ACCOUNTS_ERROR: "SETTING_GET_SELECTED_ACCOUNTS_ERROR",

  SETTING_CHANGE_OPERATING_TYPE_REQUEST:
    "SETTING_CHANGE_OPERATING_TYPE_REQUEST",
  SETTING_CHANGE_OPERATING_TYPE_COMPLETE:
    "SETTING_CHANGE_OPERATING_TYPE_COMPLETE",
  SETTING_CHANGE_OPERATING_TYPE_ERROR: "SETTING_CHANGE_OPERATING_TYPE_ERROR",

  SETTING_CHANGE_OPERATING_TYPE_RESET: "SETTING_CHANGE_OPERATING_TYPE_RESET",

  SETTING_GET_ALL_CREDIT_CARD_PREF_REQUEST:
    "SETTING_GET_ALL_CREDIT_CARD_PREF_REQUEST",
  SETTING_GET_ALL_CREDIT_CARD_PREF_COMPLETE:
    "SETTING_GET_ALL_CREDIT_CARD_PREF_COMPLETE",
  SETTING_GET_ALL_CREDIT_CARD_PREF_ERROR:
    "SETTING_GET_ALL_CREDIT_CARD_PREF_ERROR",

  SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_REQUEST:
    "SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_REQUEST",
  SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_COMPLETE:
    "SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_COMPLETE",
  SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_ERROR:
    "SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_ERROR",

  SETTING_REMOVE_CREDIT_CARD_REQUEST: "SETTING_REMOVE_CREDIT_CARD_REQUEST",
  SETTING_REMOVE_CREDIT_CARD_COMPLETE: "SETTING_REMOVE_CREDIT_CARD_COMPLETE",

  SETTING_GET_CUSTOMER_PROFILE_DATA_REQUEST:
    "SETTING_GET_CUSTOMER_PROFILE_DATA_REQUEST",
  SETTING_GET_CUSTOMER_PROFILE_DATA_COMPLETE:
    "SETTING_GET_CUSTOMER_PROFILE_DATA_COMPLETE",

  SETTING_GET_CUSTOMER_PROFILE_DATA_REQUESTS:
    "SETTING_GET_CUSTOMER_PROFILE_DATA_REQUESTS",

  VIEW_ONLY: "VIEW_ONLY",
  VIEW_AND_TRANSFERS: "VIEW_AND_TRANSFERS",
  NOT_ALLOWED: "NOT_ALLOWED",

  SAVINGS_ACCOUNT_SHORT: "SBA",
  CURRENT_ACCOUNT_SHORT: "CAA",
  FIXED_DEPOSIT_ACCOUNT_SHORT: "TDA",
  LOANS_ACCOUNT_SHORT: "LAA",

  SETTING_SET_UNAUTHENTICATED: "SETTING_SET_UNAUTHENTICATED",

  ACCOUNT_OPERATING_TYPE_TRANSFERS: "VIEW_AND_TRANSFERS",
  ACCOUNT_OPERATING_TYPE_NOT_ALLOWED: "NOT_ALLOWED",
  ACCOUNT_OPERATING_TYPE_VIEW_ONLY: "VIEW_ONLY",

  SETTING_ACCOUNT_UPDATE_PENDING: "pending",
  SETTING_ACCOUNT_UPDATE_SUCCESS: "success",
  SETTING_ACCOUNT_UPDATE_FAIL: "fail",

  SETTING_CREDIT_CARD_UPDATE_PENDING: "pending",
  SETTING_CREDIT_CARD_UPDATE_SUCCESS: "success",
  SETTING_CREDIT_CARD_UPDATE_FAIL: "fail",

  SETTING_GET_ALL_SAVING_ACCOUNTS_REQUEST:
    "SETTING_GET_ALL_SAVING_ACCOUNTS_REQUEST",
  SETTING_GET_ALL_SAVING_ACCOUNTS_COMPLETE:
    "SETTING_GET_ALL_SAVING_ACCOUNTS_COMPLETE",
  SETTING_GET_ALL_SAVING_ACCOUNTS_ERROR:
    "SETTING_GET_ALL_SAVING_ACCOUNTS_ERROR",

  UPDATE_DEFAULT_ACCOUNT_REQUEST: "UPDATE_DEFAULT_ACCOUNT_REQUEST",
  UPDATE_DEFAULT_ACCOUNT_COMPLETE: "UPDATE_DEFAULT_ACCOUNT_COMPLETE",
  UPDATE_DEFAULT_ACCOUNT_ERROR: "UPDATE_DEFAULT_ACCOUNT_ERROR",

  SET_ACCOUNT_NICKNAME_REQUEST: "SET_ACCOUNT_NICKNAME_REQUEST",
  SET_ACCOUNT_NICKNAME_COMPLETE: "SET_ACCOUNT_NICKNAME_COMPLETE",
  SET_ACCOUNT_NICKNAME_ERROR: "SET_ACCOUNT_NICKNAME_ERROR",
  SET_ACCOUNT_NICKNAME_CLEAR_ALL: "SET_ACCOUNT_NICKNAME_CLEAR_ALL",

  SETTING_OTP_PREF_GET_TWOFA_METHOD_REQUEST:
    "SETTING_OTP_PREF_GET_TWOFA_METHOD_REQUEST",
  SETTING_OTP_PREF_GET_TWOFA_METHOD_COMPLETE:
    "SETTING_OTP_PREF_GET_TWOFA_METHOD_COMPLETE",
  SETTING_OTP_PREF_GET_TWOFA_METHOD_ERROR:
    "SETTING_OTP_PREF_GET_TWOFA_METHOD_ERROR",

  SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_REQUEST:
    "SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_REQUEST",
  SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_COMPLETE:
    "SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_COMPLETE",
  SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_ERROR:
    "SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_ERROR",

  SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_REQUEST:
    "SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_REQUEST",
  SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_COMPLETE:
    "SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_COMPLETE",
  SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_ERROR:
    "SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_ERROR",

  SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_REQUEST:
    "SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_REQUEST",
  SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_COMPLETE:
    "SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_COMPLETE",
  SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_ERROR:
    "SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_ERROR",
  ON_EXIT_SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_RETRY:
    "ON_EXIT_SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_RETRY",

  BUTTON_YES: "Yes",
  BUTTON_NO: "No",

  TWO_FACTOR_METHODS: {
    SMS: "SMS",
    EMAIL: "EMAIL",
    SMS_EMAIL: "SMS_EMAIL",
  },

  TRANSFER_LIMITS_SET_SCREEN_TYPE: "TRANSFER_LIMITS_SET_SCREEN_TYPE",
  SELECTED_TRANSFER_TYPE: "SELECTED_TRANSFER_TYPE",

  TRANSFER_TYPE_TRANSFER: "transfer",
  TRANSFER_TYPE_DAILY: "daily",
  TRANSFER_TYPE_TWO_FACTOR: "twofactor",

  LIMIT_STATUS_ENABLED: "Y",
  TWO_FACTOR_STATUS_ENABLED: "Y",
  TWO_FACTOR_STATUS_DISABLED: "N",

  ACCOUNT_DEFAULT_STATUS: "Y",

  SAVING_ACCOUNT_TYPE: "SAVING",
  CURRENT_ACCOUNT_TYPE: "CURRENT",

  SETTING_CHANGE_OPERATING_TYPE_RESET: "SETTING_CHANGE_OPERATING_TYPE_RESET",
  FIXED_DEPOSIT_ACCOUNT_TYPE: "DEPOSITS",
  LOAN_ACCOUNT_TYPE: "LENDING",

  CHANGE_PASSWORD_SET_SCREEN_TYPE: "CHANGE_PASSWORD_SET_SCREEN_TYPE",

  CLEAR_TRANSFER_LIMITS: "CLEAR_TRANSFER_LIMITS",

  SETTING_GET_NOTIFICATION_CATEGORIES_REQUEST:
    "SETTING_GET_NOTIFICATION_CATEGORIES_REQUEST",
  SETTING_GET_NOTIFICATION_CATEGORIES_COMPLETE:
    "SETTING_GET_NOTIFICATION_CATEGORIES_COMPLETE",
  SETTING_GET_NOTIFICATION_CATEGORIES_ERROR:
    "SETTING_GET_NOTIFICATION_CATEGORIES_ERROR",

  UPDATE_NOTIFICATION_CATEGORY_REQUEST: "UPDATE_NOTIFICATION_CATEGORY_REQUEST",
  UPDATE_NOTIFICATION_CATEGORY_COMPLETE:
    "UPDATE_NOTIFICATION_CATEGORY_COMPLETE",
  UPDATE_NOTIFICATION_CATEGORY_ERROR: "UPDATE_NOTIFICATION_CATEGORY_ERROR",

  NOTIFICATION_IS_DISABLED: "Y",
  NOTIFICATION_IS_ENABLED: "N",
};
